import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=7c475896&scoped=true"
import script from "./Submenu.vue?vue&type=script&lang=ts"
export * from "./Submenu.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=7c475896&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c475896",
  null
  
)

export default component.exports